import React from "react";

const MineHeader = () => {
    return (
        <>
            <meta charSet="UTF-8" />
            <meta name="google" content="notranslate" />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
            />
            <title>Mines Game</title>
            <link rel="icon" href="/mines/images/bomb.svg" />
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/7.0.0/css/all.min.css"
                integrity="sha512-DxV+EoADOkOygM4IR9yXP8Sb2qwgidEmeqAEmDKIOfPRQZOWbXCzLC6vjbZyy0vPisbH2SyW27+ddLVCN+OMzQ=="
                crossOrigin="anonymous"
                referrerPolicy="no-referrer"
            />
            <link rel="stylesheet" href="/mines/css/mine.css" />
            <link
                href="/mines/images/6fd1d92e94ea3f763d7e.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/78199b38f475aa3608e6.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/300b34545b9f8f0c70bf.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/0084288924fa2c8af8c5.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/9fcc0f0280b2b11bb9f3.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/fd615fe04376b94fc3eb.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/5abf7ece2dd8eddfa7e1.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/a190e3fb3f20049f91e4.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/7f03adb38cf53ecc9072.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/e37078f3dbbb29d901f8.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/dba61fbfb55725153a5f.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/4df0624ab948f57df3ec.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/ef116471b599f6ba8cf1.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/04173e9b3c2f20c2b7dd.svg"
                rel="preload"
                as="image"
            />
            <link
                href="/mines/images/6265d390579ebba09b07.webp"
                rel="preload"
                as="image"
            />
        </>
    );
};

export default MineHeader;